export default "__VITE_ASSET__8e6b397f__"